import React, { useState, useEffect } from 'react';
import './editMyBump.css';
import black_checkmark_icon from '../../../assets/images/icons/black-checkmark-icon.png';
import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

// FUNCTIONS
import { reprocessTranscript } from '../reprocessTranscript';

const ProgressBarMyBump = ({
  videoId,
  user,
  videoTitle,
  videoQuality,
  videoDuration,
  isTranscriptReady,
  isProcessedbyAI,
  isYouTubePosted
}) => {
  const [transcriptError, setTranscriptError] = useState(false);

  useEffect(() => {
    if (user && user.uid) {
      const userDocRef = doc(db, 'users', user.uid);
      const videoDocRef = doc(userDocRef, 'bumpContent', `bump-${videoId}`);

      const unsubscribe = onSnapshot(
        videoDocRef,
        (docSnapshot) => {
          if (docSnapshot.exists()) {
            const videoData = docSnapshot.data();
            setTranscriptError(!!videoData.is_transcript_error);
          }
        },
        (error) => {
          // console.error("Error fetching video metadata in onSnapshot: ", error);
        }
      );

      return () => unsubscribe();
    }
  }, [user, videoId]);

  const handleReprocess = async () => {
    const payload = {
      user,
      generatedVideoId: videoId,
      videoTitle,
      videoQuality,
      videoDuration,
      isReprocess: true
    };

    // Optimistically clear error in UI
    setTranscriptError(false);

    const userDocRef = doc(db, 'users', user.uid);
    const videoDocRef = doc(userDocRef, 'bumpContent', `bump-${videoId}`);

    try {
      await updateDoc(videoDocRef, { is_transcript_error: false });
      await reprocessTranscript(payload);
    } catch (error) {
      // console.error('Error updating transcript error state or triggering reprocess:', error);
    }
  };

  return (
    <div className="valueBump-progress-bar">
      {/* Uploaded */}
      <div className="valueBump-progress-step valueBump-completed">
        <div className="valueBump-progress-label">Uploaded</div>
        <div className="valueBump-progress-circle-wrapper">
          <div className="valueBump-progress-circle valueBump-completed">
            <img src={black_checkmark_icon} alt="Completed" />
          </div>
          <div
            className="valueBump-progress-line"
            style={{
              backgroundColor:
                isTranscriptReady || isProcessedbyAI ? '#fff' : '#555',
              width:
                isTranscriptReady || isProcessedbyAI ? '100%' : '50%'
            }}
          ></div>
        </div>
      </div>

      {/* Analyzing */}
      <div
        className="valueBump-progress-step"
        style={{ color: isTranscriptReady ? '#fff' : '#555' }}
      >
        <div className="valueBump-progress-label">Bump-1.0 Watching</div>
        <div className="valueBump-progress-circle-wrapper">
          {!transcriptError && (
            <div
              className={`valueBump-progress-circle ${
                isTranscriptReady ? 'valueBump-completed' : 'pulsating'
              }`}
            >
              {isTranscriptReady && (
                <img src={black_checkmark_icon} alt="Completed" />
              )}
            </div>
          )}
          {transcriptError && (
            <button
              className="transcript-reprocess-button"
              onClick={handleReprocess}
            >
              Reprocess
            </button>
          )}
          <div
            className="valueBump-progress-line"
            style={{
              backgroundColor: isProcessedbyAI
                ? '#fff'
                : isTranscriptReady
                ? '#777'
                : '#555',
              width: isProcessedbyAI
                ? '100%'
                : isTranscriptReady
                ? '50%'
                : '0%'
            }}
          ></div>
        </div>
      </div>

      {/* Bump AI */}
      <div
        className="valueBump-progress-step"
        style={{ color: isProcessedbyAI ? '#fff' : '#555' }}
      >
        <div className="valueBump-progress-label">AI Description</div>
        <div className="valueBump-progress-circle-wrapper">
          <div
            className={`valueBump-progress-circle ${
              isProcessedbyAI
                ? 'valueBump-completed'
                : isTranscriptReady
                ? 'pulsating'
                : ''
            }`}
          >
            {isProcessedbyAI && (
              <img src={black_checkmark_icon} alt="Completed" />
            )}
          </div>
          <div
            className="valueBump-progress-line"
            style={{
              backgroundColor: isYouTubePosted
                ? '#fff'
                : isProcessedbyAI
                ? '#777'
                : '#555',
              width: isYouTubePosted
                ? '100%'
                : isProcessedbyAI
                ? '50%'
                : '0%'
            }}
          ></div>
        </div>
      </div>

      {/* Visibility */}
      <div
        className="valueBump-progress-step"
        style={{ color: isYouTubePosted ? '#fff' : '#555' }}
      >
        <div className="valueBump-progress-label">Visibility</div>
        <div className="valueBump-progress-circle-wrapper">
          <div
            className={`valueBump-progress-circle ${
              isYouTubePosted ? 'valueBump-completed' : ''
            }`}
          >
            {isYouTubePosted && (
              <img src={black_checkmark_icon} alt="Completed" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBarMyBump;
